{
  "nl": {
    "integration": {
      "labels": {
        "apiTokensUsedByYou": "API tokens",
        "create_failed": "Failed to create",
        "crm_id": "{integration_oid_type} ID in {integration_name}: {integration_oid}",
        "description": "Beschrijving",
        "error": "error",
        "integration": "Integratie",
        "integrationOID": "Integratie ID",
        "last_sync_with": "Last synchronization with {integration_name} ({last_sync_at})",
        "status": "status",
        "synced_at": "Laatste synchronisatie: ",
        "title": "Jullie integraties",
        "update_failed": "failed to update"
      },
      "record_actions": {
        "delete": "Om {record_type} permanent te verwijderen op Ziggu dient {record_type} <strong>eerst te worden verwijderd in {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integration gewijzigd"
      }
    }
  }
}